import { configureStore, combineReducers } from '@reduxjs/toolkit';
import authSlice from 'store/authSlice';
import appSlice from 'store/appSlice';
import commonSlice from 'store/commonSlice';
import pageSlice from 'store/pageSlice';
import { getPreloadedState, saveToLocalStorage } from 'store/localStorage';
import projectSlice from './projectSlice';
import clientSlice from './clientSlice';
import clientSliceV2 from './clientSliceV2';
import vendorSlice from './vendorSlice';
import vendorSliceV2 from './vendorSliceV2';
import projectSliceV2 from './projectSliceV2';
import locationSlice from './localtionSlice';
import vehicleSlice from './vehicleSlice';
import vehicleSliceV2 from './vehicleSliceV2';
import driverSliceV2 from './driverSliceV2';
import clientContractSlice from './clientContractSlice';
import vendorBillSlice from './vendorBillSlice';
import airSlice from './airexpenseSlice';
import dashboardSlice from './dashboardSlice';
import advancePaymentSlice from './advancePaymentSlice';
import financeSlice from './financeSlice';
import approvalSliceV2 from './approvalSliceV2';
import routeSliceV2 from './routeSliceV2';
import employeeSliceV2 from './employeeSliceV2';
import tripSliceV2 from './tripSliceV2';
import clientInvoiceSliceV2 from './clientInvoiceSliceV2';

const combinedReducer = combineReducers({
	app: appSlice,
	auth: authSlice,
	common: commonSlice,
	dashboard: dashboardSlice,
	pageState: pageSlice,
	projectState: projectSlice,
	clientState: clientSlice,
	clientStateV2: clientSliceV2,
	vendorState: vendorSlice,
	vendorStateV2: vendorSliceV2,
	projectStateV2: projectSliceV2,
	locationState: locationSlice,
	vehicleState: vehicleSlice,
	vehicleStateV2: vehicleSliceV2,
	driverStateV2: driverSliceV2,
	clientContractState: clientContractSlice,
	vendorBillState: vendorBillSlice,
	AirExpensesState: airSlice,
	advancePayment: advancePaymentSlice,
	finance: financeSlice,
	approvalStateV2: approvalSliceV2,
	routeStateV2: routeSliceV2,
	employeeStateV2: employeeSliceV2,
	tripStateV2: tripSliceV2,
	clientInvoiceStateV2: clientInvoiceSliceV2,
});

const rootReducer = (state, action) => {
	/**
	 * to reset whole app state to initial state
	 */
	if (action.type === 'auth/setUser') {
		state = undefined;
	}

	return combinedReducer(state, action);
};

const store = configureStore({
	reducer: rootReducer,
	preloadedState: getPreloadedState(),
});

function onStateChange() {
	saveToLocalStorage(store.getState());
}

store.subscribe(onStateChange);

export default store;
